/**
 * RESPONSIBILITY: whether a row's own switch says to draw it.
 *
 * ONE reading of that switch, for every kind of row that carries one — a ministry, a
 * band down a ministry page, a band on an event page. Three call sites each testing the
 * field for themselves is three chances to test it the wrong way round, and the wrong
 * way round means content that was saved correctly and never appears.
 *
 * Only an explicit NO counts. A row saved before the switch existed has no answer at
 * all, and the answer to a question nobody was asked is yes — the alternative is that
 * adding this field turns off every ministry and every band on the site at once.
 *
 * Events are not among them: an event answers the same question with a date window as
 * well as a switch, so it has its own — see isVisible in when.ts.
 */
export const isShown = (row: { show?: boolean } | undefined): boolean => row?.show !== false;
